import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@service/dashboard.service';
import { ToasterLibraryService } from '@service/index';

@Component({
    selector: 'app-recent-notes-widget',
    templateUrl: './recent-notes-widget.component.html',
    styleUrls: ['./recent-notes-widget.component.scss']
})
export class RecentNotesWidgetComponent implements OnInit {
    public isLoaded = false;
    public notes: Array<any> = [];

    constructor(
        private dashboardService: DashboardService,
        private toasterLibrary: ToasterLibraryService
    ) { }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.isLoaded = false;
        this.dashboardService.getRecentNotes().subscribe(
            (res: any) => {
                if (res && res.data && Array.isArray(res.data)) {
                    this.notes = res.data.slice(0, 5);
                } else if (Array.isArray(res)) {
                    this.notes = res.slice(0, 5);
                }
                this.isLoaded = true;
            },
            (err: any) => {
                this.toasterLibrary.error(null, err?.error?.message || 'Failed to load recent notes');
                this.isLoaded = true;
            }
        );
    }

    truncate(text: string, max: number = 100): string {
        if (!text) { return ''; }
        return text.length > max ? text.substring(0, max) + '...' : text;
    }
}